export default __webpack_public_path__ + "static/media/gallery.b9905418.svg";